import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

export function DonutChart({ data, centerLabel, centerSubLabel, height = 220, testId }) {
  return (
    <div className="relative" style={{ height }} data-testid={testId}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie data={data} dataKey="value" nameKey="name" innerRadius="62%" outerRadius="92%" paddingAngle={2} isAnimationActive animationDuration={800}>
            {data.map((d, i) => <Cell key={i} fill={d.color} stroke="none" />)}
          </Pie>
          <Tooltip formatter={(v, n) => [`${v}%`, n]} />
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        <span className="text-2xl font-bold font-mono text-slate-800">{centerLabel}</span>
        {centerSubLabel && <span className="text-[11px] text-slate-400 mt-0.5">{centerSubLabel}</span>}
      </div>
    </div>
  );
}
